module.exports = __webpack_public_path__ + "BZ.png?47300873054f64b61ea7218711c8bc2d";